"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgPackageTooltipMobile = function SvgPackageTooltipMobile(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 112,
    height: 125,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 0 1 8-8h95.54a8 8 0 0 1 8 8v116.64H0V8z",
    fill: "#4D4D4D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.77,
    y: 8,
    width: 34,
    height: 2,
    rx: 1,
    fill: "#919499"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 22a4 4 0 0 1 4-4h95.54a4 4 0 0 1 4 4v102.64H4V22z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17181A",
    d: "M8 78.727h34.036v.597H8zm0 9.554h34.036v.597H8zm53.741-9.554h34.036v.597H61.741zM8 81.115h22.691v.597H8zm0 9.554h22.691v.597H8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M8 83.504h16.122v.597H8zm0 9.554h16.122v.597H8zm53.741-9.554h16.122v.597H61.741z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17181A",
    d: "M61.741 81.115h22.093v.597H61.741z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 22,
    width: 95.54,
    height: 45.256,
    rx: 4,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.257,
    cy: 32.257,
    r: 6.486,
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54 103.029a4 4 0 0 0-4-4H12a4 4 0 0 0-4 4v13.611a4 4 0 0 0 4 4h87.54a4 4 0 0 0 4-4v-13.611z",
    fill: "#F3F2E8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M10.985 103.209h34.036v.597H10.985zm0 4.179h20.302v.597H10.985zm28.662 0h28.662v.597H39.647z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 69.77,
    width: 47.336,
    height: 4.777,
    rx: 2.388,
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 24.743,
    y1: 38.743,
    x2: 24.743,
    y2: 25.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.972,
    stopColor: "#00B0B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 55.336,
    y1: 74.547,
    x2: 55.336,
    y2: 69.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC9F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2080F1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "a",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "matrix(.00083 0 0 .00176 0 -.204)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "d",
    width: 1200,
    height: 800,
    xlinkHref: "data:image/png;base64,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"
  })));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgPackageTooltipMobile);
var _default = Memo;
exports["default"] = _default;